export const GOOGLE_SITE_KEY_PROD = '6LdIgPMjAAAAACfuP4xEDEa_HsR_ZiQzomomTh27'
